// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"5ccf7713","299":"bec2a03e","383":"ea77c5ec","451":"77fa5953","720":"3884a184","908":"305cf275"}[chunkId] + ".chunk.js";
};